import NotificationModal from "../../Notification/NotificationModal";
import BalanceModal from "../../Modals/BalanceModal";
import PendingModal from "../../Modals/PendingModal";
import OffersDrawer from "../../Modals/OffersDrawer/OffersDrawer";
import TermAndConditionsModal from "../../Authentications/SignUp/TermsAndConditionsModal";
import ProfileDrawer from "../../Modals/ProfileDrawer";
import ReceivedDrawer from "../../Modals/ReceivedDrawer";

export default function NavModals({
  isTermsModalOpen,
  terms,
  setIsTermsModalOpen,
  isBalanceVisible,
  orders,
  onCancel,
  isPendingOrdersVisible,
  isPendingOrders,
  showNotificationModal,
  selectedItem,
  onNotCancel,
  handleRenderParents,
  handleBuyingFromStore,
  isOffersVisible,
  purchase,
  dir,
  handleOffer,
  onOffersClose,
  isMoneyVisible,
  moneyCollection,
  handleReceivedConfirmation,
  setIsMoneyVisible,
  showProfileDrawer,
  setShowProfileDrawer,
}) {
  return (
    <>
      {isTermsModalOpen && (
        <TermAndConditionsModal
          isOpen={isTermsModalOpen}
          data={terms}
          onCancel={() => setIsTermsModalOpen(false)}
        />
      )}
      {isBalanceVisible && (
        <BalanceModal
          isModalOpen={isBalanceVisible}
          onCancel={onCancel}
          data={orders}
          title={"My Balance"}
        />
      )}
      {isPendingOrdersVisible && (
        <PendingModal
          isModalOpen={isPendingOrdersVisible}
          onCancel={onCancel}
          isPendingOrders={isPendingOrders}
        />
      )}
      {showNotificationModal && (
        <NotificationModal
          isOpen={showNotificationModal}
          onCancel={onNotCancel}
          selectedItem={selectedItem}
          handleRenderParents={handleRenderParents}
          onBuyingFromStore={handleBuyingFromStore}
        />
      )}
      {isOffersVisible && (
        <OffersDrawer
          data={purchase}
          onOffersClose={onOffersClose}
          isOffersVisible={isOffersVisible}
          dir={dir}
          handleOffer={handleOffer}
        />
      )}
      {isMoneyVisible && (
        <ReceivedDrawer
          data={moneyCollection}
          onMoneyClose={() => setIsMoneyVisible(false)}
          isMoneyVisible={isMoneyVisible}
          dir={dir}
          handleReceivedConfirmation={handleReceivedConfirmation}
        />
      )}
      {showProfileDrawer && (
        <ProfileDrawer
          open={showProfileDrawer}
          dir={dir}
          onClose={() => setShowProfileDrawer(false)}
        />
      )}
    </>
  );
}
